import { useState, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';

function DarkModeToggle() {
  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
    localStorage.setItem('darkMode', isDark);
  }, [isDark]);

  return (
    <button
      onClick={() => setIsDark(!isDark)}
      data-testid="dark-mode-toggle"
      className="w-9 h-9 flex items-center justify-center rounded-xl hover:bg-[#E8E0D4]/50 dark:hover:bg-[#2A2520]/50 transition-colors"
      aria-label="Toggle dark mode"
    >
      {isDark ? <Sun className="w-4 h-4 text-[#B0A0C0]" /> : <Moon className="w-4 h-4 text-[#6B5A7B]" />}
    </button>
  );
}

export default DarkModeToggle;
